import { resetCreateUsersDemos } from 'common/api/siteTourDemo';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';
import _ from 'lodash';
import { FC } from 'react';
import { DemoPages } from './type';

type SiteTourResetButtonProps = {
  pageName: DemoPages;
};

const SiteTourResetButton: FC<SiteTourResetButtonProps> = ({ pageName }) => {
  const handleClick = _.debounce(() => {
    resetCreateUsersDemos(pageName)
      .then(() => window.location.reload())
      .catch((error) => {
        console.error('Error resetting site tour:', error);
        reactToastify('Failed to reset site tour. Please try again.', TOASTIFY_TYPES.ERROR);
      });
  }, 300);

  return (
    <div className="select-tour-rest-button">
      <i
        className="fa-light fa-square-question"
        onClick={handleClick}
        title="Click to Show Site Tour"
        data-toggle="tooltip"
        data-placement="bottom"
      />
    </div>
  );
};

export default SiteTourResetButton;
